module.exports = __webpack_public_path__ + "static/media/2022-january-article.e5d4e3d6.jpg";